/**
 * 主界面中心组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
	<div id="page-wrapper" class="gray-bg dashbard-1">
		<ContentHeader 
			v-on:showtip="opentip"
			></ContentHeader>
		<ContentNav></ContentNav>
		<ContentBody></ContentBody>
		<ContentFooter></ContentFooter>
	</div>
</template>

<script>
    import ContentFooter from 'components/layouts/ContentFooter'
    import ContentHeader from 'components/layouts/ContentHeader'
    import ContentNav from 'components/layouts/ContentNav'
    import ContentBody from 'components/layouts/ContentBody'
	export default {
		name: 'MainContent',
		components: {
			ContentFooter,
			ContentHeader,
			ContentNav,
			ContentBody
		},
		methods:{
			opentip(tip){
				this.$emit('opentip',tip)
			}
		}
	};
</script>


// WEBPACK FOOTER //
// MainContent.vue?7d443caf